(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('release', {
            parent: 'app',
            url: '/release?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Release'
            },
            views: {
                'content@': {
                    templateUrl: 'app/release/release.html',
                    controller: 'ReleaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('situacaoRelease');
                    $translatePartialLoader.addPart('tipoRelease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('release-detail', {
                parent: 'release',
                url: '/release?{sistemaId}&{versao}&{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'chamadosApp.release.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/release/release-detail.html',
                        controller: 'ReleaseDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('situacaoChamado');
                        $translatePartialLoader.addPart('situacaoRelease');
                        $translatePartialLoader.addPart('tipoRelease');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Release', function ($stateParams, Release) {
                        if ($stateParams.id) {
                            return Release.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                        return Release.getByVersao({
                            versao: $stateParams.versao,
                            sistema: {id: $stateParams.sistemaId}
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'release',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
    }
})();
